exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-other[data-v-9048f284]{display:inline-block;width:250px}@media (max-width:767px){.input-other[data-v-9048f284]{display:inline-block;width:210px}}", ""]);

// exports
